import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import MetaFileLink from 'src/app/models/metaFileLink.model';

@Component({
  selector: 'terra-download-file',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadFileComponent implements OnInit {

  @Input() metaFileLink:MetaFileLink;
  @Input() text:string;

  @Output() clickFnc = new EventEmitter<MetaFileLink>();
  
  constructor() { }

  ngOnInit(): void {
  }

  onClick(file:MetaFileLink){
    this.clickFnc.emit(file);
  }

}
